import { render, staticRenderFns } from "./ChatDeleteConfirmModal.vue?vue&type=template&id=7c1a5edb"
import script from "./ChatDeleteConfirmModal.vue?vue&type=script&lang=js"
export * from "./ChatDeleteConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports